<script setup>
import { onMounted, ref } from 'vue'
import { useJobStore } from '@/stores/job'
import JobFormBase from './JobFormBase.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const jobStore = useJobStore()

const props = defineProps({
  job: {
    type: Object,
    default: () => ({})
  }
})

const job = ref(JSON.parse(JSON.stringify(props.job)))

onMounted(() => {
  job.value = { status: jobStore.statusOptions[0], ...props.job }
})

const emits = defineEmits(['close'])

const submit = async () => {
  const id = job.value.id
    ? await jobStore.updateJob(job.value)
    : await jobStore.createJob(job.value)

  if (job.value.id) {
    emits('close')
  } else if (id) {
    router.push(`/jobs/${id}`)
    emits('close')
  }
}
</script>

<template>
  <form @submit.prevent="submit">
    <div class="flex flex-col gap-4">
      <JobFormBase v-model="job" />

      <div class="flex gap-4">
        <Button fluid severity="secondary" outlined label="ביטול" @click="emits('close')" />
        <Button fluid :label="job.id ? 'שמירה' : 'צור'" type="submit" :loading="jobStore.loading" />
      </div>
    </div>
  </form>
  <!-- <pre>{{ job }}</pre> -->
</template>
